<h3-unscope-object-button matRipple></h3-unscope-object-button>

@let shapeItems = shapeItems$ | async;
@if (shapeItems?.length > 0) {
  <div class="shape-lists">
    <h3-shape-list [shapeItems]="shapeItems"></h3-shape-list>
  </div>
}

<h3-annotation-list-section class="object-list-section">
  <h3-annotation-list-section-header
    *ngIf="showAttachedObjectsHeader$ | async"
    label="ATTACHED OBJECTS"
  ></h3-annotation-list-section-header>
  <h3-object-list
    cdkDropList
    [cdkDropListSortingDisabled]="true"
    [class.no-drag-animation]="skipDragAnimation$ | async"
  ></h3-object-list>
</h3-annotation-list-section>
